import api from "../utils/api";
import { buildAnalyticsSearchParams } from "./analyticsParams";

export async function getDashboardOverview(filters = {}) {
  const params = buildAnalyticsSearchParams(filters);

  return (
    await api.get(
      `/api/admin/dashboard/overview?${params.toString()}`,
    )
  ).data;
}
